import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../../buttons/buttons";
import { numberWithCommas } from "../../helpers";
import { storePublicCartProducts } from "../../../redux/cart/cartAction";

export default React.forwardRef(function GuestPaymentFailure(
  {
    visibility = false,
    primaryButtonTitle,
    primaryButton,
    primaryButtonStyle,
    primaryButtonClassName,
    modalTitle,
    modalTitleSection,
    modelContent,
    modelContentSection,
    disableClose = false,
    disableOpen = false,
    onOpen = () => { },
    onClose = () => { },
    paymentRef,
  },
  ref
) {
  // Ref handler
  React.useImperativeHandle(ref, () => ({
    open: () => openModal(),
    close: () => closeModal(),
  }));

  const navigate = useNavigate();
  let [isOpen, setIsOpen] = React.useState(visibility);

  function closeModal() {
    !disableClose && setIsOpen(false);
    !disableClose && onClose();
    handleSubmit();
  }

  function openModal() {
    !disableOpen && setIsOpen(true);
    !disableOpen && onOpen();
    // paymentRef.current.close();
  }

  const dispatch = useDispatch();
  const [myCart, setMyCart] = useState([]);
  const { cartProducts } = useSelector((state) => state.cart);

  const cart_data = {
    "products": null,
    "packages": null,
    "coupons": [],
    "promotion_codes": [],
    "sub_amount": 0,
    "amount": 0,
    "discount": 0,
    "service_fee": 0,
    "delivery_fee": 0,
    "insurance_fee": 0,
    "tax_fee": 0,
    "weight_in_kg": 0,
    "meta": []
  }
  useEffect(() => {
    cartProducts && setMyCart(cartProducts?.data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartProducts]);

  const handleSubmit = async () => {
    const response = await dispatch(storePublicCartProducts(cart_data));
    if (response) {
      navigate(`/user/home`);
    }
  }

  return (
    <React.Fragment>
      <Transition appear show={visibility || isOpen} as={React.Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-full bg-white dark:bg-[#121212] rounded-sm px-4 pt-5 pb-4  overflow-hidden shadow-xl transform transition-all sm:my-10 sm:max-w-[900px] sm:min-h-[400px] sm:p-8">
                  {/* <div className="sm:block absolute top-2 right-3 pt-4 pr-4">
                    <button type="button" className="" onClick={closeModal}>
                      <span className="sr-only">Close</span>
                      <img
                        src={CLOSE}
                        alt="close"
                        className=" w-3 h-3 sm:w-4 sm:h-4"
                      />
                    </button>
                  </div> */}
                  <div className="sm:flex sm:items-start">
                    <div className="text-center mx-auto max-w-[600px]">
                      <div className="flex justify-center my-10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="130"
                          height="130"
                          viewBox="0 0 130 130"
                          fill="none"
                        >
                          <path
                            opacity="0.1"
                            d="M95.3914 0H34.6666C12.5378 0 0 12.5378 0 34.6666V95.3335C0 117.462 12.5378 130 34.6666 130H95.3914C117.52 130 130 117.462 130 95.3335V34.6666C130 12.5378 117.52 0 95.3914 0Z"
                            fill="#CE2600"
                          />
                          <path
                            d="M65 32.5C57.3625 32.5 50.2938 35.1813 44.6875 39.65C37.2125 45.5813 32.5 54.7625 32.5 65C32.5 71.0938 34.2063 76.8625 37.2125 81.7375C42.8188 91.1625 53.1375 97.5 65 97.5C73.2062 97.5 80.6813 94.4938 86.3688 89.375C88.8875 87.2625 91.0812 84.6625 92.7875 81.7375C95.7938 76.8625 97.5 71.0938 97.5 65C97.5 47.0437 82.9562 32.5 65 32.5ZM52.1625 60.6125C49.8063 58.2562 49.8063 54.3562 52.1625 52C54.6 49.6437 58.4187 49.6437 60.8562 52L65.0813 56.3063L69.1438 52.1625C71.5813 49.8063 75.4 49.8063 77.8375 52.1625C80.1937 54.6 80.1937 58.4187 77.8375 60.8562L73.6938 64.9187L78 69.1438C80.3563 71.5813 80.3563 75.4 78 77.8375C76.7812 78.975 75.2375 79.5438 73.6938 79.5438C72.15 79.5438 70.6063 78.975 69.3875 77.8375L65.0813 73.5312L60.6125 78C59.3938 79.2188 57.85 79.7875 56.3062 79.7875C54.7625 79.7875 53.2188 79.2188 52 78C49.6438 75.6438 49.6438 71.7438 52 69.3875L56.4688 64.9187L52.1625 60.6125Z"
                            fill="#CE2600"
                          />
                        </svg>
                      </div>

                      <Dialog.Title
                        as="h1"
                        className="text-3xl font-bold text-black dark:text-white mb-3"
                      >
                        Payment Failed
                      </Dialog.Title>

                      <p className="text-lg">Your order payment failed. Please try another payment method! </p>

                    </div>
                  </div>


                  {/* Cart Product list */}
                  {myCart?.products?.length > 0 || myCart?.packages?.length > 0 ? (
                    <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mt-6 mb-10 border-2 border-[0, 0%, 92%, 1] rounded-lg">
                      <h3 className="text-2xl font-bold text-left text-black dark:text-white mb-4">Order Items</h3>
                      {/* Products */}
                      {myCart?.products?.length > 0 &&
                        myCart.products.map((product, i) => (
                          <div key={i + product.id}>
                            <div className="flex justify-between items-start mb-5">
                              <div className="flex">
                                <span className="w-6 mr-10">{product.quantity}X</span>
                                <div>
                                  <p className="mb-2 capitalize">
                                    {product?.food_name || product?.merchandise_name}
                                  </p>
                                  {product?.attributes?.length > 0 &&
                                    product?.attributes?.map((attr, i) => (
                                      <p key={i + attr?.name} className="text-sm capitalize">
                                        {attr.quantity}x {attr?.name}
                                      </p>
                                    ))}
                                  <p className="text-xs text-gray-500 mt-1">
                                    {product?.product_outlet_name}
                                  </p>
                                </div>
                              </div>
                              <div className="flex gap-4">
                                <p>
                                  ₦
                                  {numberWithCommas(
                                    (product?.food_amount || product?.merchandise_amount) *
                                    product.quantity
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}

                      {/* Packages */}
                      {myCart?.packages?.length > 0 &&
                        myCart.packages.map((pkg, i) => (
                          <div key={i + pkg.id}>
                            <div className="flex justify-between items-start mb-5">
                              <div className="flex">
                                <span className="w-6 mr-10">{pkg.quantity}X</span>
                                <div>
                                  <p className="mb-2 capitalize">{pkg?.package_name}</p>
                                  <p className="text-xs text-gray-500 mt-1">
                                    Package
                                  </p>
                                </div>
                              </div>
                              <div className="flex gap-4">
                                <p>
                                  ₦{numberWithCommas(pkg?.package_amount * pkg.quantity)}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  ) : (
                    <div className="rounded-lg bg-white dark:bg-[#121212] sm:max-w-3xl overflow-hidden px-4 py-5 mt-6 mb-10 shadow-[0px_18px_40px_0px_#7090B01F]">
                      <div className="text-center py-8">
                        <p className="text-gray-500 dark:text-gray-400 mb-2">
                          Your cart is empty
                        </p>
                        <p className="text-sm text-gray-400 dark:text-gray-500">
                          Add items to your cart to proceed with checkout
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="max-w-[540px] mx-auto">
                    <Button.Primary
                      title={"Back to Home"}
                      className={"w-full h-[48px] px-4 mt-6 mb-4"}
                      onClick={() => handleSubmit()}
                    />
                    <p className="text-xl font-bold text-black dark:text-white mb-3">For order details and more information, check your email.</p>
                    <p className="text-lg">Please contact our support team for any issues and we’ll be happy to assist you.</p>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </React.Fragment>
  );
});
